import NextImage from "@/app/components/lib/NextImage";
import React from "react";

interface props {
  src?: string;
  name?: string;
}
const CommentAvatar: React.FC<props> = ({ name, src }) => {
  const getRandomColor = () => {
    const colors = ["#F44336", "#2196F3", "#4CAF50", "#FFC107", "#9C27B0"];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  const getInitials = (name: string) => {
    const names = name.split(" ");
    return names
      .map((n, idx) => (idx > 1 ? "" : n[0]))
      .join("")
      .toUpperCase();
  };
  const renderAvatar = () => {
    if (src) {
      return (
        <div className="avatar">
          <NextImage src={src} alt={name!} />
        </div>
      );
    } else {
      const initials = getInitials(name!);
      const backgroundColor = getRandomColor();
      return (
        <div className="avatar-text" style={{ backgroundColor }}>
          {initials}
        </div>
      );
    }
  };

  return <>{renderAvatar()}</>;
};

export default React.memo(CommentAvatar);
